module.exports = __webpack_public_path__ + "media/images/icons/outlined/credit-card-a9d2c2100d0fa1bcb5a4504166a29e65.svg";